import styled from "@emotion/styled";

import {
  MDSButton,
  MDSButtonSize,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconKind,
} from "@/mds";

export const AgentBackLink = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <StyledButton size={MDSButtonSize.Small} variant={MDSButtonVariant.Transparent} onPress={onClick}>
    <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.AngleLeft} />
    {label}
  </StyledButton>
);

const StyledButton = styled(MDSButton)`
  align-self: flex-start;
  margin-left: ${({ theme }) => `-${theme.spacing["2"]}`};
`;
